import React, { memo, useState, useCallback } from 'react';
import { createUseStyles, Text, Icon, Popover, useTheme } from '@Sage/hoi-poi-ui';
import classnames from 'classnames';
import AnimateHeight from 'react-animate-height';
import styles from "./styles.FiltersSection";
const useStyles = createUseStyles(styles, 'FiltersSection');
const FiltersSection = _ref => {
  let {
    title,
    filterNum,
    children,
    className,
    headerClassName,
    hint
  } = _ref;
  const [open, setOpen] = useState(true);
  const classes = useStyles();
  const theme = useTheme();
  const rootClass = classnames(classes.root, className, {
    [classes.expanded]: open
  });
  const headerClass = classnames(classes.header, headerClassName);
  const toggle = useCallback(() => {
    setOpen(!open);
  }, [open]);
  return /*#__PURE__*/React.createElement("div", {
    className: rootClass
  }, /*#__PURE__*/React.createElement("div", {
    className: headerClass,
    onClick: toggle
  }, /*#__PURE__*/React.createElement(Text, {
    className: classes.title,
    type: "subtitle"
  }, title, filterNum && ` (${filterNum})`), hint && /*#__PURE__*/React.createElement(Popover, {
    trigger: ['hover'],
    content: /*#__PURE__*/React.createElement("div", {
      className: classes.hintContent
    }, hint.title && /*#__PURE__*/React.createElement(Text, {
      type: "subtitle",
      medium: true
    }, hint.title), hint.description && /*#__PURE__*/React.createElement(Text, {
      color: theme.colors.textLight.secondary,
      className: classes.hintContentDescription
    }, hint.description))
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.hint
  }, /*#__PURE__*/React.createElement(Icon, {
    name: hint.icon || 'helpOutline',
    color: "currentColor"
  }), hint.new && /*#__PURE__*/React.createElement(Text, {
    color: theme.colors.actionMajor[500],
    type: "caption",
    className: classes.new
  }, hint.new))), /*#__PURE__*/React.createElement(Icon, {
    className: classes.icon,
    name: "expandLess",
    size: "large"
  })), /*#__PURE__*/React.createElement(AnimateHeight, {
    height: open ? 'auto' : 0
  }, children));
};
export default /*#__PURE__*/memo(FiltersSection);